import { DateTime } from 'luxon';
import type { AllocationTransactionDto } from '@/entities/allocations/allocation.entity.ts';
import { AllocationStatus, AllocationType } from '@carvia/ros-client-types';

export function getAllocationTransactionCharacteristics(
  transaction: AllocationTransactionDto | undefined,
) {
  if (!transaction) {
    return {
      isHandover: false,
      isReturn: false,
      isWorkshopHandover: false,
      isWorkshopReturn: false,
      isSwap: false,
      isLateHandover: false,
      isLateReturn: false,
      hasTransferReturn: false,
      hasTransferDelivery: false,
      isPartnerRent: false,
      isPartnerRentHandover: false,
      isPartnerRentReturn: false,
    };
  }

  const isBookingHandover =
    transaction.type === AllocationType.BOOKING &&
    transaction.status === AllocationStatus.CONFIRMED;
  const isWorkshopHandover =
    transaction.type === AllocationType.WORKSHOP_APPOINTMENT &&
    transaction.status === AllocationStatus.CONFIRMED;
  const isHandover = isBookingHandover || isWorkshopHandover;

  const isBookingReturn =
    transaction.type === AllocationType.BOOKING &&
    transaction.status === AllocationStatus.HANDED_OVER;
  const isWorkshopReturn =
    transaction.type === AllocationType.WORKSHOP_APPOINTMENT &&
    transaction.status === AllocationStatus.HANDED_OVER;
  const isReturn = isBookingReturn || isWorkshopReturn || !!transaction.swapFromId;

  return {
    isHandover: isHandover,
    isWorkshopHandover,
    isWorkshopReturn,
    isReturn: isReturn,
    isSwap:
      !!transaction.swapFromId ||
      (isBookingHandover && !transaction.isFirstBookingAllocation) ||
      (isBookingReturn && !transaction.isLastBookingAllocation),
    isLateHandover:
      isHandover && DateTime.fromISO(transaction.startDate).diffNow('hours').hours < -12,
    isLateReturn: isReturn && DateTime.fromISO(transaction.endDate).diffNow('hours').hours < -12,
    hasTransferDelivery: !!transaction.transfers?.some(
      (transfer) => transfer.type === AllocationType.TRANSFER_DELIVERY,
    ),
    hasTransferReturn: !!transaction.transfers?.some(
      (transfer) => transfer.type === AllocationType.TRANSFER_RETURN,
    ),
    isPartnerRent: transaction.type === AllocationType.PARTNER_BOOKING,
    isPartnerRentHandover:
      transaction.type === AllocationType.PARTNER_BOOKING &&
      transaction.status === AllocationStatus.CONFIRMED,
    isPartnerRentReturn:
      transaction.type === AllocationType.PARTNER_BOOKING &&
      transaction.status === AllocationStatus.HANDED_OVER,
  };
}
